
import React from "react";
import {IProductHostsWrapper} from "../interfaces";
import WindowsIcon from "../../../../ui/svg/common/windows";
import AppleIcon from "../../../../ui/svg/common/apple";


export interface IProductHostsProps {
    productHostsWrapper?:IProductHostsWrapper
}
/**
 * the entry point
 */
const TabSupportedHosts = (props?: IProductHostsProps) => {

    const productHostsWrapper = props?.productHostsWrapper;
    return (
        <div className="my-4">
            {productHostsWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: productHostsWrapper?.topBanner }} />}
            {
                productHostsWrapper != null && productHostsWrapper.topLeftLink !== undefined &&
                <div className={'my-4 w-full justify-start'}>
                    <a href="/support/waves-with-apple-m1-processors">Apple Silicon Support</a>
                </div>
            }
            {productHostsWrapper != null && productHostsWrapper.productHosts.length > 0 &&
                <div className="product-hosts-list flex flex-col md:flex-row justify-between my-4">
                <ul className="mac w-full flex flex-col justify-start md:mr-12 xl:mr-36">
                    <li className="icon flex w-full h-12 mb-8 items-center justify-start">
                        <span><AppleIcon width="34" height="40" color="1d1d1d"/></span>
                        <span className="ml-4 text-xl font-bold text-gray-700">Mac</span>
                    </li>
                    {
                        productHostsWrapper?.productHosts?.filter(w => w.osid === 1).map((ph, index) => {
                            return (
                                <li key={index}
                                    className="w-full mb-6 items-center justify-start">
                                    <div className="w-full">
                                        <span className="pr-1" dangerouslySetInnerHTML={{__html: ph.hostName}}/>
                                        <span className="pr-1" dangerouslySetInnerHTML={{__html: ph.hostVersion}}/>
                                        <span className="pr-1 text-sm text-gray-400"
                                              dangerouslySetInnerHTML={{__html: ph.hostFormat}}/>
                                    </div>
                                    <div className="w-full text-xs text-green"
                                         dangerouslySetInnerHTML={{__html: ph.hostComment}}/>
                                    <div className="w-full text-xs text-green"
                                         dangerouslySetInnerHTML={{__html: ph.productHostComment}}/>
                                </li>
                            )
                        })
                    }
                </ul>
                <ul className="windows w-full flex flex-col justify-start">
                    <li className="icon flex w-full h-12 mb-8 items-center justify-start">
                        <span><WindowsIcon width="38" height="38" color="1d1d1d"/></span>
                        <span className="ml-4 text-xl font-bold text-gray-700">Windows</span>
                    </li>
                    {
                        productHostsWrapper?.productHosts?.filter(w => w.osid === 2)?.map((ph, index) => {
                            return (
                                <li key={index}
                                    className="w-full mb-6 items-center justify-start">
                                    <div className="w-full">
                                        <span className="pr-1" dangerouslySetInnerHTML={{__html: ph.hostName}}/>
                                        <span className="pr-1" dangerouslySetInnerHTML={{__html: ph.hostVersion}}/>
                                        <span className="pr-1 text-sm text-gray-400"
                                              dangerouslySetInnerHTML={{__html: ph.hostFormat}}/>
                                    </div>
                                    <div className="w-full text-xs text-green"
                                         dangerouslySetInnerHTML={{__html: ph.hostComment}}/>
                                    <div className="w-full text-xs text-green"
                                         dangerouslySetInnerHTML={{__html: ph.productHostComment}}/>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
            }
            {productHostsWrapper != null && <div className={"my-8"} dangerouslySetInnerHTML={{ __html: productHostsWrapper?.bottomBanner }} />}
        </div>
    )
};

export default TabSupportedHosts;